import { SproutWidgetFrame } from '@fruitful/agent-ui';
import { WidgetType } from '@fruitful/types';
import React, { type ReactNode } from 'react';
import ErrorBoundary from 'react-native-error-boundary';
import { BodySmallRegular, YStack } from 'smoothie';

import { captureException } from '../../../logger/Logger';

const SPROUT_CHAT_WIDGET_TYPES = new Set<WidgetType>([
    WidgetType.Chart,
    WidgetType.FreeToSpend,
    WidgetType.CardDetails,
    WidgetType.AccountBalances,
    WidgetType.Transactions,
    WidgetType.IncomeSplit,
    WidgetType.MoneyMap,
    WidgetType.InlineDataTable,
    WidgetType.SendToGuide,
    WidgetType.EmailSupport,
]);

export const isSproutChatWidget = (widget: WidgetType): boolean =>
    SPROUT_CHAT_WIDGET_TYPES.has(widget);

interface ChatWidgetErrorBoundaryProps {
    widget: WidgetType;
    messageId: string;
    onError?: () => void;
    children: ReactNode;
}

const SPROUT_WIDGET_UNAVAILABLE_MESSAGE =
    "This visual isn't available right now.";

const SproutWidgetUnavailableFallback = (_props: {
    error: Error;
    resetError: () => void;
}) => (
    <SproutWidgetFrame>
        <YStack width="100%" padding={16} alignItems="center">
            <BodySmallRegular color="$gray1000" textAlign="center">
                {SPROUT_WIDGET_UNAVAILABLE_MESSAGE}
            </BodySmallRegular>
        </YStack>
    </SproutWidgetFrame>
);

export const ChatWidgetErrorBoundary = ({
    widget,
    messageId,
    onError,
    children,
}: ChatWidgetErrorBoundaryProps) => (
    <ErrorBoundary
        FallbackComponent={SproutWidgetUnavailableFallback}
        onError={(error, stackTrace) => {
            captureException(error, {
                widget,
                messageId,
                stackTrace,
            });
            onError?.();
        }}
    >
        {children}
    </ErrorBoundary>
);
